import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl';
import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';
import { VODCSSModules } from 'shared/utils/wix-connect';

import Icon from 'shared/components/icon/icon';
import { LinkButton } from 'shared/components/button/button';
import Button from 'widget/components/button/button';

import { PAYMENT_PERMS, PAYMENT_TYPE } from 'shared/constants/payments';

import styles from './channel-subscription.styl';

import translations from './translations';


export class ChannelSubscriptionBase extends React.Component {

  static propTypes = {
    onSubscribeClick: React.PropTypes.func,
    onSubscriptionCancelClick: React.PropTypes.func,
    channelData: React.PropTypes.object,
    className: React.PropTypes.string,
    biEvent: React.PropTypes.func,
  };

  get content() {
    const { onSubscribeClick, onSubscriptionCancelClick, channelData: { dgsInfo, dealInfo } } = this.props;
    const subscriptionDealInfo = dealInfoHelpers.getSubscriptionPriceInfo(dealInfo);

    if (dgsInfo && dgsInfo.subscription) {
      const { dateTs, price, currency } = dgsInfo.subscription;
      const values = {
        date: <FormattedDate value={dateTs * 1000}
                             year="numeric"
                             month="long"
                             day="2-digit" />,
        price: <FormattedNumber value={price}
                                style="currency"
                                currency={currency} />,
      };

      return (
        <div>
          <div styleName="subscription-price">
            <FormattedMessage {...translations.subscribedSince}
                              values={values} />
          </div>

          <LinkButton styleName="cancel-button"
                      onClick={onSubscriptionCancelClick}>
            <FormattedMessage {...translations.cancelSubscription} />
          </LinkButton>
        </div>
      );
    }

    return (
      <div>
        <div styleName="subscription-price">
          <FormattedMessage {...translations.subscriptionMonth}
                            values={{
                              price: <FormattedNumber value={subscriptionDealInfo.price}
                                                      style="currency"
                                                      currency={subscriptionDealInfo.currency} />,
                            }} />
        </div>

        {this.subscriptionPerms}

        <Button styleName="subscribe-button"
                onClick={onSubscribeClick}>
          <FormattedMessage {...translations.subscribeToChannel} />
        </Button>
      </div>
    );
  }

  get subscriptionPerms() {
    const dealInfo = dealInfoHelpers.getSubscriptionPriceInfo(this.props.channelData.dealInfo);

    if (!dealInfo) {
      return null;
    }

    return _.map(PAYMENT_PERMS[PAYMENT_TYPE.SUBSCRIPTION], permTitle => (
      <div styleName="permission"
           key={permTitle}>
        <Icon styleName="icon"
              name="arrow-right-filled" />
        <FormattedMessage {...translations[permTitle]}
                          values={dealInfo} />
      </div>
    ));
  }

  render() {
    const { className, channelData: { title } } = this.props;

    return (
      <div className={className}>
        <div styleName="popout-title">
          {title}
        </div>

        {this.content}
      </div>
    );
  }
}

const ChannelSubscription = VODCSSModules(styles)(ChannelSubscriptionBase);
export default ChannelSubscription;



// WEBPACK FOOTER //
// ./src/widget/components/payments/channel-subscription.js